/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleDto } from './RoleDto';
import {
    RoleDtoFromJSON,
    RoleDtoFromJSONTyped,
    RoleDtoToJSON,
    RoleDtoToJSONTyped,
} from './RoleDto';

/**
 * 
 * @export
 * @interface UserWithRolesDto
 */
export interface UserWithRolesDto {
    /**
     * 
     * @type {string}
     * @memberof UserWithRolesDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithRolesDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithRolesDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithRolesDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithRolesDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserWithRolesDto
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof UserWithRolesDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserWithRolesDto
     */
    lastLoginAt?: Date | null;
    /**
     * 
     * @type {Array<RoleDto>}
     * @memberof UserWithRolesDto
     */
    roles?: Array<RoleDto> | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithRolesDto
     */
    fullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithRolesDto
     */
    initials?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithRolesDto
     */
    primaryOrganizationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithRolesDto
     */
    primaryOrganizationName?: string | null;
}

/**
 * Check if a given object implements the UserWithRolesDto interface.
 */
export function instanceOfUserWithRolesDto(value: object): value is UserWithRolesDto {
    return true;
}

export function UserWithRolesDtoFromJSON(json: any): UserWithRolesDto {
    return UserWithRolesDtoFromJSONTyped(json, false);
}

export function UserWithRolesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserWithRolesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'emailConfirmed': json['emailConfirmed'] == null ? undefined : json['emailConfirmed'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'lastLoginAt': json['lastLoginAt'] == null ? undefined : (new Date(json['lastLoginAt'])),
        'roles': json['roles'] == null ? undefined : ((json['roles'] as Array<any>).map(RoleDtoFromJSON)),
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'initials': json['initials'] == null ? undefined : json['initials'],
        'primaryOrganizationId': json['primaryOrganizationId'] == null ? undefined : json['primaryOrganizationId'],
        'primaryOrganizationName': json['primaryOrganizationName'] == null ? undefined : json['primaryOrganizationName'],
    };
}

export function UserWithRolesDtoToJSON(json: any): UserWithRolesDto {
    return UserWithRolesDtoToJSONTyped(json, false);
}

export function UserWithRolesDtoToJSONTyped(value?: UserWithRolesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'userName': value['userName'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'emailConfirmed': value['emailConfirmed'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'lastLoginAt': value['lastLoginAt'] == null ? value['lastLoginAt'] : value['lastLoginAt'].toISOString(),
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(RoleDtoToJSON)),
        'fullName': value['fullName'],
        'initials': value['initials'],
        'primaryOrganizationId': value['primaryOrganizationId'],
        'primaryOrganizationName': value['primaryOrganizationName'],
    };
}

